import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  PieChart as RechartsPieChart,
  Pie,
  Cell,
  Tooltip,
  Legend
} from 'recharts';

function PieChart({ data, options }) {
  // Transform Chart.js data format to Recharts format
  // Chart.js format: { labels: [...], datasets: [{data: [...], ...}] }
  // Recharts format: [{ name: 'label', value: number }, ...]

  const transformData = () => {
    if (!data || !data.labels || !data.datasets || !data.datasets[0]) {
      return [];
    }

    return data.labels.map((label, index) => ({
      name: label,
      value: data.datasets[0].data[index]
    }));
  };

  const chartData = transformData();

  // Define color palette with gray tones and some accent colors
  const COLORS = [
    '#374151', // gray-700
    '#6b7280', // gray-500
    '#9ca3af', // gray-400
    '#d1d5db', // gray-300
    '#4b5563', // gray-600
    '#1f2937', // gray-800
    '#6366f1', // indigo-500 (accent)
    '#8b5cf6', // violet-500 (accent)
    '#ec4899', // pink-500 (accent)
    '#f59e0b', // amber-500 (accent)
  ];

  return (
    <div className="w-full h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
}

PieChart.propTypes = {
  data: PropTypes.object.isRequired,
  options: PropTypes.object
};

export default PieChart;
